export enum NegativeFeedbackReasonEnum {
  WRONG = "WRONG_INFORMATION",
  PARTIALLY_CORRECT_OR_INCOMPLETE = "PARTIALLY_CORRECT_OR_INCOMPLETE",
  OFF_TOPIC = "OFF_TOPIC",
  OTHER = "OTHER",
}
